<div [class.striped]="striped">
  <mat-table
    [dataSource]="dataSource"
    matSort
    [matSortActive]="sortKey"
    [matSortDirection]="sortDirection"
    matSortDisableClear
    (matSortChange)="onSortChange($event)"
    [multiTemplateDataRows]="true"
    data-pw="table"
    style="width: 100%">
    <!-- Regular columns -->
    @for (column of columnDefinitions; track column.name) {
      <ng-container [matColumnDef]="column.name">
        <mat-header-cell
          *matHeaderCellDef
          class="cfi-mat-table-cell-padded"
          [mat-sort-header]="column.sortable ? column.name : ''"
          [attr.aria-label]="!column.header || column.header.trim() === '' ? column.name + ' column' : null"
          [style.width.%]="column.width"
          [style.min-width.%]="column.width"
          [class.no-sort]="!column.sortable"
          [class.no-click]="!column.sortable && !column.checkbox"
          [class.action]="column.action"
          [class.centered]="column.centered"
          data-pw="header">
          <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: column }"></ng-container>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          class="cfi-mat-table-cell-padded"
          (click)="row.expandable && toggleRow(row, $event)"
          [class.clickable]="row.expandable"
          [class.action]="column.action"
          [style.width.%]="column.width"
          [style.min-width.%]="column.width"
          [attr.data-pw]="'cell-' + column.name"
          [class.centered]="column.centered">
          @if (column.toggleExpand) {
            <ng-container>
              @if (hasSubCells(row)) {
                <button
                  mat-icon-button
                  class="mr-2"
                  (click)="toggleRow(row, $event)"
                  data-pw="toggleExpand"
                  aria-label="Toggle Expand Row">
                  <mat-icon>{{ isExpanded(row) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                </button>
              }
            </ng-container>
          }
          <ng-container>
            <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: row, column: column }"></ng-container>
          </ng-container>
        </mat-cell>
      </ng-container>
    }

    <!-- Expanded Content Column -->
    <ng-container matColumnDef="expandedDetails">
      <td
        mat-cell
        *matCellDef="let cell"
        [attr.colspan]="columnsToDisplayWithExpand.length"
        style="padding: 0"
        data-pw="expandedDetails">
        <div
          class="cfi-mat-table-expandable-element"
          [class.cfi-mat-table-expandable-element-expanded]="isExpanded(cell)"
          data-pw="expandedContent">
          <div class="cfi-mat-table-expanded-detail-content">
            <table
              mat-table
              [dataSource]="cell.subCells"
              class="cfi-mat-table-expanded-cell__table"
              data-pw="subCellsTable">
              <ng-container matColumnDef="content">
                <td
                  mat-cell
                  *matCellDef="let subCell"
                  class="cfi-mat-table-cell cfi-mat-table-cell-padded"
                  style="padding-left: 16px; padding-right: 16px"
                  data-pw="subCell">
                  <div class="cfi-mat-table-cell__expanded-container">
                    <ng-container *ngTemplateOutlet="expandedRow; context: { $implicit: subCell }"></ng-container>
                  </div>
                </td>
              </ng-container>

              <tr
                mat-row
                *matRowDef="let subCell; columns: ['content']"
                class="cfi-mat-table-row"
                [class.selected]="selectedCell === subCell"
                (click)="selectCell(subCell)"
                data-pw="subCellRow"></tr>
            </table>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Header Row -->
    @if (showHeader) {
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" data-pw="headerRow"></mat-header-row>
    }

    <!-- Regular Data Row -->
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.expanded-row]="isExpanded(row)"
      (click)="row.expandable && toggleRow(row, $event)"
      [class.clickable]="row.expandable"
      [class]="rowClass ? rowClass(row) : ''"
      [attr.data-pw]="'row-' + row.id">
    </mat-row>

    <!-- Expanded Detail Row -->
    @if (allowExpand) {
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetails']; when: isExpandedRow"
        [class.detail-expanded]="isExpanded(row)"
        [class.detail-collapsed]="!isExpanded(row)"
        class="cfi-mat-table-example-detail-row"
        [attr.data-pw]="'expandedRow-' + row.id"></tr>
    }
  </mat-table>

  @if (paginated) {
    <mat-paginator
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="currentPageSize"
      [hidePageSize]="hidePageSizeSelector"
      [pageIndex]="currentPageIndex"
      [length]="totalRows"
      (page)="onPageFired($event)"
      data-pw="paginator">
    </mat-paginator>
  }
</div>
